import React from 'react';

import { mapValues } from 'lodash';

import { faBullseyeArrow } from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow';
import { faCheckDouble } from '@fortawesome/pro-regular-svg-icons/faCheckDouble';
import { faPuzzle } from '@fortawesome/pro-regular-svg-icons/faPuzzle';
import { faRocket } from '@fortawesome/pro-regular-svg-icons/faRocket';
import { faShieldHalved } from '@fortawesome/pro-regular-svg-icons/faShieldHalved';
import { faStars } from '@fortawesome/pro-regular-svg-icons/faStars';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

export const MY_CHANCES_ICONS = {
  likely: {
    icon: faShieldHalved,
    color: 'tealXtraDark',
    chipColor: 'teal',
    tooltip: 'Likely College',
    chance: 'Safety',
    text: 'Your stats exceed admission standards',
  },
  target: {
    icon: faBullseyeArrow,
    color: 'pinkXtraDark',
    chipColor: 'pink',
    tooltip: 'Target College',
    chance: 'Target',
    text: 'Your stats meet most admission standards',
  },
  reach: {
    icon: faRocket,
    color: 'violetXtraDark',
    chipColor: 'violet',
    tooltip: 'Reach College',
    chance: 'Reach',
    text: 'Your stats meet some admission standards',
  },
  far_reach: {
    icon: faStars,
    color: 'indigoXtraDark',
    chipColor: 'indigo',
    tooltip: 'Far Reach College',
    chance: 'Far reach',
    text: 'Your stats meet few admission standards',
  },
  guaranteed: {
    icon: faCheckDouble,
    color: 'greenDark',
    chipColor: 'green',
    tooltip: 'Guaranteed College',
  },
  other: {
    icon: faPuzzle,
    color: 'blueSteelDark',
    chipColor: 'blueSteel',
    tooltip: 'Other',
  },
};

export const getMyChancesObject = ({ field, iconColor, iconSize } = {}) =>
  Object.fromEntries(
    Object.keys(MY_CHANCES_ICONS).map(key => [
      key,
      field ? (
        MY_CHANCES_ICONS[key][field]
      ) : (
        <FontAwesomeIcon
          key={key}
          color={iconColor || MY_CHANCES_ICONS[key].color}
          icon={MY_CHANCES_ICONS[key].icon}
          size={iconSize || undefined}
        />
      ),
    ]),
  );

export const DESIGNATION_DETAILS = mapValues(
  getMyChancesObject({ iconSize: 'xl' }),
  value => ({
    Icon: value,
  }),
);

export const ADMISSION_STATS_TAB = 1;
export const FINAL_LIST_TAB = 2;

export const nationalDataKey = 'national';
export const districtDataKey = 'district';
export const schoolDataKey = 'school';
